export default __webpack_public_path__ + "static/media/PUNKS-HAT-FRONT.40e68351.png";